export const issueTemplate = {
  high: { label: "High", detailLabel: "High Priority" },
  info: { label: "Info" },
  medium: { label: "Medium", detailLabel: "Medium Priority" },
  low: { label: "Low", detailLabel: "Low Priority" },
  pending: { label: "Pending", detailLabel: "Pending Priority" },
};



// WEBPACK FOOTER //
// ./src/templates/IssueTemplate.js